import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, FlagIcon, BookOpenIcon, ActivityIcon, CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const features = [{
    icon: <FileTextIcon className="w-3 h-3" data-id="element-105" />,
    text: '100% PDF'
  }, {
    icon: <ZapIcon className="w-3 h-3" data-id="element-106" />,
    text: 'Acceso en 5 min'
  }, {
    icon: <FlagIcon className="w-3 h-3" data-id="element-107" />,
    text: 'Hecho para Argentina'
  }, {
    icon: <BookOpenIcon className="w-3 h-3" data-id="element-108" />,
    text: '6 Tomos completos'
  }, {
    icon: <ActivityIcon className="w-3 h-3" data-id="element-109" />,
    text: 'Masa → Negocio en pesos'
  }, {
    icon: <CheckCircleIcon className="w-3 h-3" data-id="element-110" />,
    text: '3 Bonos incluidos'
  }];
  const stats = ['+500 emprendedoras confían', '6 Tomos listos', '3 Bonos incluidos', '4,9/5 ⭐'];
  return <section className="w-full bg-white py-8 md:py-24" data-id="element-111">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-113">
          <div className="mb-4 md:mb-8" data-id="element-114">
            <span className="text-orange-500 font-bold text-sm tracking-wider" data-id="element-115">
              🍩 RECURSOHUB™
            </span>
          </div>

          <h1 className="md:text-6xl lg:text-7xl text-gray-900 mb-2 md:mb-4 text-[28px] font-[700]" data-id="element-116">
            Todo lo que necesitás para hacer minidonas y venderlas desde casa.
          </h1>

          <h2 className="md:text-5xl lg:text-6xl font-bold text-orange-500 mb-6 md:mb-10 text-[24px]" data-id="element-117">
            Listo para empezar este fin de semana.
          </h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.7
        }} className="mb-6 md:mb-10" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/ar6b9q3sQdWJfAd37KVcnh/donas_(1).png" alt="Mega Pack Emprende Minidonas 360 — 6 Tomos + 3 Bonos" className="max-w-md md:max-w-lg lg:max-w-2xl mx-auto w-full h-auto" data-id="element-119" />
          </motion.div>

          <div className="mb-3 md:mb-6" data-id="element-120">
            <p className="md:text-lg text-orange-500 font-medium text-[14px]" data-id="element-121">
              El sistema N°1 para emprender con minidonas desde casa en
              Argentina
            </p>
          </div>

          <p className="md:text-lg text-gray-600 mb-6 md:mb-10 max-w-3xl mx-auto text-[14px]" data-id="element-122">
            Recetas + técnicas + packaging + precios + marketing listos para
            usar. Sin buscar en YouTube. Sin probar recetas que no salen. Sin
            perder plata en ingredientes tirados a la basura.
          </p>

          <div className="flex flex-wrap justify-center gap-1.5 mb-6 md:mb-10" data-id="element-123">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: index * 0.1,
            duration: 0.3
          }} className="flex items-center gap-1 bg-orange-50 border border-orange-200 rounded-full px-2.5 py-1" data-id="element-124">
                <span className="text-orange-500" data-id="element-125">{feature.icon}</span>
                <span className="text-xs text-gray-600 font-medium" data-id="element-126">
                  {feature.text}
                </span>
              </motion.div>)}
          </div>

          <motion.a href="#elegi-tu-pack" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-lg mb-4 md:mb-6 transition-colors shadow-lg shadow-orange-500/20 cursor-pointer" data-id="element-127">
            🔴 → QUIERO MI MEGA PACK AHORA
          </motion.a>

          <p className="text-sm text-gray-500 mb-6 md:mb-12" data-id="element-128">
            🛡️ Garantía 7 días · 🔒 Pago seguro · 💳 Mercado Pago
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 max-w-3xl mx-auto" data-id="element-129">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8 + index * 0.1,
            duration: 0.4
          }} className="bg-orange-50 border border-orange-200 rounded-lg p-3 md:p-4" data-id="element-130">
                <p className="text-sm md:text-base font-semibold text-gray-900" data-id="element-131">
                  {stat}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}